import { AxiosResponse } from "axios";
import {
  DashboardFilterType,
  DashboardTransactionsDetail,
  Saturation,
  SlotCapacity,
} from "reducers/types/dashboard";
import {
  DelayedTripsResponseType,
  PointStatusResponseType,
  dashboardResponseDataType,
} from "sagas/types/dashboard";
import * as API from "./api";
import { SlotDetail } from "reducers/types/dashboardSlotCapacityModal";

export const getDashboard = (
  params: DashboardFilterType
): Promise<AxiosResponse<dashboardResponseDataType>> => {
  const { ...filters } = params;
  return API.get("/ms-admin-rest/api/v1.0/transactions/dashboard", filters);
};

export const getSaturation = (
  params: DashboardFilterType
): Promise<AxiosResponse<API.ApiResponseResult<Saturation[]>>> => {
  const { ...filters } = params;
  return API.get(
    "/ms-admin-rest/api/v1.0/transactions/saturation-zone",
    filters
  );
};

export const getSlotCapacity = (
  params: DashboardFilterType
): Promise<AxiosResponse<API.ApiResponseResult<SlotCapacity[]>>> => {
  const { ...filters } = params;
  return API.get("/ms-admin-rest/api/v1.0/slots/capacity", filters);
};

export const getSlotDetail = (
  params: number
): Promise<AxiosResponse<API.ApiResponseResult<SlotDetail>>> => {
  const filters = { slotId: params };
  return API.get("/ms-admin-rest/api/v1.0/slots/picker-details", filters);
};

export const getDelayedTrips = (
  params: DashboardFilterType
): Promise<AxiosResponse<DelayedTripsResponseType>> => {
  const { ...filters } = params;
  return API.get("/ms-admin-rest/api/v1.0/trips/delayed", {
    ...filters,
  });
};
export const getPointStatus = (
  params: DashboardFilterType
): Promise<AxiosResponse<PointStatusResponseType>> => {
  const { ...filters } = params;
  return API.get("/ms-admin-rest/api/v1.0/points/origin", filters);
};
export const getTransactionsDetail = (
  params: DashboardFilterType
): Promise<
  AxiosResponse<API.ApiResponseResult<DashboardTransactionsDetail>>
> => {
  const { ...filters } = params;
  return API.get("/ms-admin-rest/api/v1.0/transactions/quantity", filters);
};
